// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__6pPV-","items":"Footer_items__qL2RF","text":"Footer_text__GENzN"};